import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "primary--text font-weight-bold"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_MessageHandle = _resolveComponent("MessageHandle")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_app_bar, {
        color: "primary",
        dark: "",
        flat: "",
        app: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            style: {"position":"absolute"},
            icon: "",
            onClick: _ctx.routerBack
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode("mdi-chevron-left", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_toolbar_title, { style: {"min-width":"fit-content"} }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('communication.newBroadcastMessage')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_spacer)
        ]),
        _: 1
      }),
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_container, { class: "new-message-padding-box" }, {
            default: _withCtx(() => [
              (_ctx.allClass)
                ? (_openBlock(), _createBlock(_component_v_select, {
                    key: 0,
                    class: "mt-2",
                    variant: "outlined",
                    label: _ctx.$t('form.recipient'),
                    modelValue: _ctx.inputAdresses,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputAdresses) = $event)),
                    items: _ctx.allClass,
                    "item-title": "className",
                    "item-value": "classId",
                    color: "primary",
                    chips: "",
                    "closable-chips": "",
                    multiple: ""
                  }, null, 8, ["label", "modelValue", "items"]))
                : _createCommentVNode("", true),
              _createVNode(_component_v_textarea, {
                modelValue: _ctx.title,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.title) = $event)),
                label: _ctx.$t('form.title'),
                variant: "outlined",
                rules: [_ctx.rules.required],
                rows: "2",
                "hide-details": "",
                dense: "",
                class: "mb-5",
                color: "primary"
              }, null, 8, ["modelValue", "label", "rules"]),
              _createVNode(_component_v_textarea, {
                label: _ctx.$t('form.content'),
                variant: "outlined",
                rows: "17",
                "hide-details": "",
                dense: "",
                modelValue: _ctx.inputText,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inputText) = $event)),
                color: "primary"
              }, null, 8, ["label", "modelValue"]),
              (!_ctx.isChatCreateUserMe)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.$t('communication.viewOnly')), 1))
                : _createCommentVNode("", true),
              _createVNode(_component_MessageHandle, {
                onSaveDraft: _ctx.saveDraft,
                onSaveSendReady: _ctx.saveSendReady,
                onSendMessage: _ctx.sendMessage,
                btnSendLoading: _ctx.btnSendLoading,
                btnDraftLoading: _ctx.btnDraftLoading,
                btnReadyLoading: _ctx.btnReadyLoading,
                inputText: _ctx.inputText,
                isChatCreateUserMe: _ctx.isChatCreateUserMe
              }, null, 8, ["onSaveDraft", "onSaveSendReady", "onSendMessage", "btnSendLoading", "btnDraftLoading", "btnReadyLoading", "inputText", "isChatCreateUserMe"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_snackbar, {
        modelValue: _ctx.snackbar,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.snackbar) = $event)),
        timeout: _ctx.timeout,
        outlined: "",
        top: "",
        color: "primary"
      }, {
        actions: _withCtx(() => [
          _createVNode(_component_v_btn, {
            color: "outline-primary",
            variant: "text",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.snackbar = false))
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode(" × ", -1)
            ]))]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.snackBarText) + " ", 1)
        ]),
        _: 1
      }, 8, ["modelValue", "timeout"])
    ]),
    _: 1
  }))
}